import styled from 'styled-components';

const OutOfStockText = styled.h1`
  font-family: 'Avenir Light', 'Arial', sans-serif;
  font-size: ${({ fontSize }) => fontSize || '13px'};
  letter-spacing: initial;
  line-height: ${({ lineHeight }) => lineHeight || 'initial'};
  margin: 0;
  text-align: center;
  text-transform: initial;
`;

export default OutOfStockText;
